import { chargeServiceMatrixConstants } from '../../_constants';

export function chargeServiceMatrix(state = {}, action) {
    switch (action.type) {
        case chargeServiceMatrixConstants.CHARGE_MATRIX_FETCHING:
            return {
                ...state,
                fetchingCSM: true
            };
        case chargeServiceMatrixConstants.CHARGE_MATRIX_FETCHED:
            return {
                ...state,
                fetchingCSM: false
            };
        case chargeServiceMatrixConstants.GET_CHARGE_SERVICE_MATRIX:
            return {
                ...state,
                chargesServiceMatrix: action.chargesServiceMatrix,
            };
        case chargeServiceMatrixConstants.GET_CHARGE_SERVICE_MATRIX_BY_ID:
            return {
                ...state,
                chargeServiceMatrix: action.chargeServiceMatrix
            };
        case chargeServiceMatrixConstants.UPDATE_CHARGE_SERVICE_MATRIX:
            return {
                ...state,
                updating: true
            };
        case chargeServiceMatrixConstants.SEARCH_CHARGE_SERVICE_MATRIX:
            return {
                ...state,
                chargesServiceMatrix: action.chargesServiceMatrix
            };
        case chargeServiceMatrixConstants.GET_FULL_CHARGE_SERVICE_MATRIX:
            return {
                ...state,
                chargesServiceMatrix: action.chargesServiceMatrix
            };
        default:
            return state;
    }
}